import { setCustomerFocus, getTagList } from '@/utils/api/customer.js'
import permissionVerificationMinxins from './permission-verification.js'
export default {
  mixins: [permissionVerificationMinxins],
  data() {
    return {
      pageSize: 10,
      curPage: 1,
      keywordOptions: [
        {
          key: 'keyword',
          name: '关键词',
        },
        {
          key: 0,
          name: '标签',
        },
      ],
      attentionStatus: 0, // 特别关注
      tableData: [],
      total: null,
      loading: false,
      isShowTooltip: false,
    }
  },
  methods: {
    // 当keyword左边选择框发生变化时
    keySelectChange() {
      this.searchData.tags = []
      this.searchData.keyword = ''
    },

    // 特别关注发生变化时
    attentionChange() {
      this.searchData = JSON.parse(JSON.stringify(this.copySearchData))
      this.curPage = 1
      this.recoverArea()
      if (this.attentionStatus == 20) {
        this.attentionStatus = 0
      } else {
        this.attentionStatus = 20
      }
      this.getList()
    },

    // 搜索
    search() {
      this.copySearchData = JSON.parse(JSON.stringify(this.searchData))
      this.curPage = 1
      this.getList()
    },

    // 每页条数改变时
    sizeChange(size) {
      this.searchData = JSON.parse(JSON.stringify(this.copySearchData))
      this.handleSelectionList=[]
      this.recoverArea()
      this.pageSize = size
      this.curPage = 1
      this.getList()
    },

    // 页数改变时
    currentChange(cur) {
      this.searchData = JSON.parse(JSON.stringify(this.copySearchData))
      this.recoverArea()
      this.curPage = cur
      this.handleSelectionList=[]
      this.getList()
    },

    // 根据客户等级返回等级和颜色
    levelComp(code) {
      const obj = {
        str: '',
        color: '',
      }
      switch (code) {
        case 10:
          obj.str = 'A'
          obj.color = '#EF2A2A'
          break
        case 20:
          obj.str = 'B'
          obj.color = '#E6A23C'
          break
        case 30:
          obj.str = 'C'
          obj.color = '#4F5D78'
      }
      return obj
    },

    // 默认提供一个，当组件没有提供会走这个
    recoverArea() {},

    // 当排序规则变更时
    sortChange(sort) {
      this.searchData = JSON.parse(JSON.stringify(this.copySearchData))
      this.recoverArea()
      this.sort = {
        sortType: sort.order && (sort.order === 'ascending' ? 1 : 2),
        attribute: sort.order && sort.prop,
      }
      this.getList()
    },

    renderHeader() {
      return <i class="iconfont icon-icon-shoucangxianxing"></i>
    },

    // 点击收藏
    async handleCollect(id, status) {
      try {
        const res = await setCustomerFocus({
          id,
          attentionStatus: status == 20 ? 10 : 20,
        })
        if (res.rspResult.bizCode === 200) {
          this.getList()
        }
      } catch(err) {
        console.error("❌ ~ file: customerList.js:137 ~ handleCollect ~ err:", err)
      }
    },

    // 获取标签选项
    async getInitTagList() {
      try {
        const res = await getTagList()
        if (res.rspResult.bizCode === 200) {
          this.tagList = res.rspListData.list
        }
      } catch(err) {
        console.error("❌ ~ file: customerList.js:149 ~ getInitTagList ~ err:", err)
      }
    },

    // 点击打开详情
    openDetail(id, index) {
      this.isAnalysis=true
      this.companyData = {
        id,
        ids: this.tableData.map(ele => ele.id),
        index,
      }
      const ref = this.$refs.detailDrawer
      ref.isList = true
      ref.isCustomerDetail = true
      ref.visible = true
    },

    // 当详情抽屉关闭时，重新获取列表数据
    anewList() {
      this.searchData = JSON.parse(JSON.stringify(this.copySearchData))
      this.recoverArea()
      this.getList(false)
      if(this.findIndustryData) this.findIndustryData()
    },

    // 处理Tooltip溢出时才显示。
    onMouseOver(str) { // 内容超出，显示文字提示内容
      this.$nextTick(() => {
        const tag = this.$refs[str]
        const parentWidth = tag.parentNode.offsetWidth // 获取元素父级可视宽度
        const contentWidth = tag.offsetWidth // 获取元素可视宽度
        this.isShowTooltip = contentWidth <= parentWidth
      })
    },

    // 标签颜色
    tagColors(item) {
      let rgb = "";
      switch (item.color) {
        case "#20B820":
          rgb = "32, 184, 32";
          break;
        case "#9255DE":
          rgb = "146, 85, 222";
          break;
        case "#F2BD00":
          rgb = "242, 189, 0";
          break;
        case "#FF7F2A":
          rgb = "255, 127, 42";
          break;
        case "#2F53EB":
          rgb = "47, 83, 235";
          break;
      }
      return {
        rgb
      };
    },

    // 返回表格顶部
    returnTop() {
      try {
        document.querySelector('.el-table__body-wrapper').scrollTop = 0
      } catch(err) {
        console.error("❌ ~ file: customerList.js:217 ~ returnTop ~ err:", err)
      }
    }
  },

  mounted() {
    // 修改分页默认文字为 "跳转"
    try {
      document.getElementsByClassName(
        'el-pagination__jump'
      )[0].childNodes[0].nodeValue = '跳转'
    } catch(err) {
      console.error("❌ ~ file: customerList.js:216 ~ mounted ~ err:", err)
    }
  },
}
